import styled from 'styled-components';
import { Breadcrumbs as BreadcrumbsComponent } from '@prisjakt/ui/breadcrumbs';
import { layout } from 'src/components/base';
import PromoBanner from '../../../../components/campaign-banners/promo-banner';

export const StyledPromoBanner = styled(PromoBanner)`
  margin-left: ${layout.pageContent.gutter.rem};
  margin-right: ${layout.pageContent.gutter.rem};
`;

export const Breadcrumbs = styled(BreadcrumbsComponent)`
  margin: 0 ${layout.measurements.spacing050};
  margin-top: ${layout.measurements.spacing050};
`;
